import { Informacao } from "components/Informacao";
import { ModalCustom } from "components/ModalCustom";

interface IProps {
  show: boolean;
  carregando: boolean;
  onCancelar: () => void;
  onConfirmar: () => void;
}

export function RemoverLoteModal({
  show,
  carregando,
  onCancelar,
  onConfirmar,
}: IProps) {
  return (
    <ModalCustom
      show={show}
      handleClose={carregando ? () => {} : onCancelar}
      title="Remover lote"
      centered
      footer
      footerConfirmButton
      confirmButtonText="Remover"
      onConfirm={onConfirmar}
      disabledConfirmButton={carregando}
    >
      <p>Deseja remover o lote selecionado?</p>
      <Informacao
        type="atencao"
        mensagem={
          <span>
            Os itens do lote retornarão para a aba <strong>Solicitações</strong>
            .
          </span>
        }
        showLabel={false}
        showBotaoFechar={false}
      />
    </ModalCustom>
  );
}
